module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "tk-sku_chooser",
    attrs: {
      "data-com": "TkSkuChooser"
    }
  }, [_vm._l((_vm.options), function(oOpt) {
    return [_c('dt', {
      staticClass: "tk-sku_chooser-label"
    }, [_vm._v(_vm._s(oOpt.name))]), _vm._v(" "), _vm._l((oOpt.values), function(val, nIndex) {
      return _c('dd', {
        staticClass: "tk-sku_chooser-key"
      }, [_c('YuButton', {
        staticClass: "tk-sku_chooser-btn",
        class: {
          'i-on': _vm.isChoose(oOpt.id, nIndex + 1),
            'i-can': _vm.canChoose(oOpt.id, nIndex + 1),
        },
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.fnChoose(oOpt.id, nIndex + 1)
          }
        }
      }, [_vm._v(_vm._s(val || '默认'))])], 1)
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a75aca","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/Sku/Chooser.vue
// module id = 287
// module chunks = 0